import { useTranslation } from 'react-i18next';
import CompareTariffsRow from '../CompareTariffsRow/CompareTariffsRow';
import CompareTariffsHeader from '../CompareTariffsHeader/CompareTariffsHeader';
import {
  compareTariffsData,
  SECTIONS_ORDER,
} from './CompareTariffsTable.constants';

import styles from './CompareTariffsTable.module.sass';

const CompareTariffsTable = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.table}>
      <CompareTariffsHeader />

      {SECTIONS_ORDER.map((section) => (
        <div key={section} className={styles.section}>
          <div className={styles.sectionTitle}>
            {t(`translation.${section}_section`)}
          </div>
          {compareTariffsData
            .filter((row) => row.section === section)
            .map((row) => (
              <CompareTariffsRow
                key={row.key}
                title={t(`translation.${row.key}_title`) || ''}
                lite={t(`translation.${row.key}_lite`, {
                  defaultValue: row.data?.lite ?? null,
                })}
                pro={t(`translation.${row.key}_pro`, {
                  defaultValue: row.data?.pro ?? null,
                })}
                proPlus={t(`translation.${row.key}_proPlus`, {
                  defaultValue: row.data?.proPlus ?? null,
                })}
              />
            ))}
        </div>
      ))}
    </div>
  );
};

export default CompareTariffsTable;
